import { computed } from 'vue'
import { useI18nStore } from '~/stores/i18n'

/**
 * 다국어 composable.
 *
 * 사용 예)
 * ```vue
 * <script setup>
 * const { t, locale, setLocale } = useLocale()
 * </script>
 * <template>
 *   <el-button>{{ t('BTN_SAVE') }}</el-button>
 * </template>
 * ```
 */
const LOCALE_CODE_MAP: Record<string, string> = { ko: 'ko-KR', en: 'en-US' }

export const useLocale = () => {
  const store = useI18nStore()

  const t = (key: string, params?: Record<string, string | number> | (string | number)[]): string =>
    store.t(key, params)

  const locale         = computed(() => store.locale)
  const localeCode     = computed(() => LOCALE_CODE_MAP[store.locale] ?? 'ko-KR')
  const setLocale      = (lang: string) => store.setLocale(lang)
  const availableLocales = ['ko', 'en']

  return { t, locale, localeCode, setLocale, availableLocales }
}
